var map = {
	"./jf01.webp": 1731,
	"./jf02.webp": 1010,
	"./jf03.webp": 3773,
	"./jf04.webp": 2700,
	"./jf05.webp": 9791,
	"./jf06.webp": 7342,
	"./jf07.webp": 3417,
	"./jf8.webp": 4464
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9163;